import { Component, Vue } from "vue-property-decorator";
import CountDown from "@/components/CountDown.vue";

import { setBgPic } from "./JustBgPic";

@Component({
  components: {
    CountDown
  }
})
export default class HochzeitComp extends Vue {
  moveDancer(): void {
    const dNow = new Date();
    const seconds: number = Math.floor(Number(dNow) / 1000);
    const minute: number = Math.floor((seconds % 3600) / 60) % 2;
    if (seconds > 0) {
      const s = seconds % 60;
      let multi = 7.4;
      if (window.innerWidth < 400) {
        multi = 3.8;
      }
      if (minute === 0) {
        this.margLeft = "margin-left:" + (multi * 59 - multi * s) + "px";
      } else {
        this.margLeft = "margin-left:" + multi * s + "px";
      }
      setTimeout(this.moveDancer, 1010 - (Number(dNow) % 1000));
    }
  }

  breitWindow = "width:400px";

  windoResize(): void {
    let wWidth: number = window.innerWidth;
    wWidth = Math.min(1440, Math.max(200, wWidth * 0.85));
    this.breitWindow = "width:" + wWidth.toString() + "px";
  }

  mounted(): void {
    setBgPic(document, true);
    const strRahel = "Rahel Kruse";
    const strHermann = "Hermann Kruse";
    const seconds: number = Math.floor(Number(new Date()) / 1000);
    if (seconds % 2 === 0) {
      this.n1 = strRahel;
      this.n2 = strHermann;
    } else {
      this.n2 = strRahel;
      this.n1 = strHermann;
    }
    this.moveDancer();
    this.windoResize();
    window.addEventListener("resize", this.windoResize);
  }

  margLeft = "margin-left:0px";
  n1 = "";
  n2 = "";
}
